module.exports = {
      id: "facebook-usage",
      viewBox: "0 0 7 15",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#facebook",
      toString: function () {
        return this.url;
      }
    }